// Per-browser-session gate for the "first check is free" rule.
// sessionStorage is scoped to the tab and cleared when the tab/window closes,
// which matches "one free check per session". It's a UX nudge only — the API
// stays authoritative. The flag is set ONLY after a check SUCCEEDS, so a failed
// request never burns the free check.
const KEY = "blendsafe.first_check_used.v1";

export function hasUsedFreeCheck() {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    // Storage blocked — fail closed so we still prompt sign-in.
    return true;
  }
}

export function markFreeCheckUsed() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* server remains authoritative */
  }
}
